var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVastuLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 227,
    height: 59,
    viewBox: "0 0 227 59",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -40,
    y: -40,
    width: 306.812,
    height: 138.273,
    fill: "#e9602a"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(20px)",
      clipPath: "url(#bgblur_0_38_5468_clip_path)",
      height: "100%",
      width: "100%"
    },
    fill: "#e9602a"
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6725 58.2749C44.5079 58.2749 57.345 45.2296 57.345 29.1375C57.345 13.0453 44.5079 0 28.6725 0C12.8371 0 0 13.0453 0 29.1375C0 45.2296 12.8371 58.2749 28.6725 58.2749ZM33.2191 33.7241L41.688 16.27L24.2338 24.7388L15.765 42.193L33.2191 33.7241Z",
    fill: "#e9602a",
    fillOpacity: 0.35
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6725 58.2749C44.5079 58.2749 57.345 45.2296 57.345 29.1375C57.345 13.0453 44.5079 0 28.6725 0C12.8371 0 0 13.0453 0 29.1375C0 45.2296 12.8371 58.2749 28.6725 58.2749ZM33.2191 33.7241L41.688 16.27L24.2338 24.7388L15.765 42.193L33.2191 33.7241Z",
    fill: "#e9602a",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6654 41.1375H77.1478L67.701 16.7149H73.6327L80.4066 35.4987L87.1439 16.7149H93.0756L83.6654 41.1375Z",
    fill: "#e9602a",
    fillOpacity: 0.35
  })), /*#__PURE__*/React.createElement("path", {
    d: "M83.6654 41.1375H77.1478L67.701 16.7149H73.6327L80.4066 35.4987L87.1439 16.7149H93.0756L83.6654 41.1375Z",
    fill: "#e9602a",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.009 41.1375H111.334L109.796 36.9267H98.8847L97.3468 41.1375H91.6348L101.082 16.7149H107.599L117.009 41.1375ZM108.368 32.423L104.34 21.2186L100.276 32.423H108.368Z",
    fill: "#e9602a",
    fillOpacity: 0.35
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117.009 41.1375H111.334L109.796 36.9267H98.8847L97.3468 41.1375H91.6348L101.082 16.7149H107.599L117.009 41.1375ZM108.368 32.423L104.34 21.2186L100.276 32.423H108.368Z",
    fill: "#e9602a",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M117.95 37.6956L120.806 33.7411C122.527 35.5353 125.2 37.0365 128.568 37.0365C131.425 37.0365 132.816 35.6817 132.816 34.2904C132.816 32.4596 130.692 31.8371 127.873 31.178C123.882 30.2626 118.756 29.1642 118.756 23.7085C118.756 19.6441 122.271 16.3487 128.019 16.3487C131.901 16.3487 135.123 17.5204 137.539 19.754L134.647 23.562C132.669 21.7312 130.033 20.8891 127.653 20.8891C125.31 20.8891 124.065 21.9143 124.065 23.3789C124.065 25.0266 126.115 25.5392 128.935 26.1983C132.962 27.1137 138.089 28.322 138.089 33.7411C138.089 38.2082 134.903 41.5769 128.312 41.5769C123.625 41.5769 120.257 40.0024 117.95 37.6956Z",
    fill: "#e9602a",
    fillOpacity: 0.35
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117.95 37.6956L120.806 33.7411C122.527 35.5353 125.2 37.0365 128.568 37.0365C131.425 37.0365 132.816 35.6817 132.816 34.2904C132.816 32.4596 130.692 31.8371 127.873 31.178C123.882 30.2626 118.756 29.1642 118.756 23.7085C118.756 19.6441 122.271 16.3487 128.019 16.3487C131.901 16.3487 135.123 17.5204 137.539 19.754L134.647 23.562C132.669 21.7312 130.033 20.8891 127.653 20.8891C125.31 20.8891 124.065 21.9143 124.065 23.3789C124.065 25.0266 126.115 25.5392 128.935 26.1983C132.962 27.1137 138.089 28.322 138.089 33.7411C138.089 38.2082 134.903 41.5769 128.312 41.5769C123.625 41.5769 120.257 40.0024 117.95 37.6956Z",
    fill: "#e9602a",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M152.834 41.1375H147.598V21.2918H140.458V16.7149H159.937V21.2918H152.834V41.1375Z",
    fill: "#e9602a",
    fillOpacity: 0.35
  })), /*#__PURE__*/React.createElement("path", {
    d: "M152.834 41.1375H147.598V21.2918H140.458V16.7149H159.937V21.2918H152.834V41.1375Z",
    fill: "#e9602a",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M163.89 31.3977V16.7149H169.163V31.2146C169.163 34.6199 171.03 36.9633 174.838 36.9633C178.573 36.9633 180.441 34.6199 180.441 31.2146V16.7149H185.713V31.3611C185.713 37.4393 182.235 41.5769 174.838 41.5769C167.369 41.5769 163.89 37.4027 163.89 31.3977Z",
    fill: "#e9602a",
    fillOpacity: 0.35
  })), /*#__PURE__*/React.createElement("path", {
    d: "M163.89 31.3977V16.7149H169.163V31.2146C169.163 34.6199 171.03 36.9633 174.838 36.9633C178.573 36.9633 180.441 34.6199 180.441 31.2146V16.7149H185.713V31.3611C185.713 37.4393 182.235 41.5769 174.838 41.5769C167.369 41.5769 163.89 37.4027 163.89 31.3977Z",
    fill: "#e9602a",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M191.113 39.8559C191.113 39.0138 191.845 38.2815 192.724 38.2815C193.603 38.2815 194.372 39.0138 194.372 39.8559C194.372 40.7347 193.603 41.5036 192.724 41.5036C191.845 41.5036 191.113 40.7347 191.113 39.8559Z",
    fill: "#e9602a",
    fillOpacity: 0.35
  })), /*#__PURE__*/React.createElement("path", {
    d: "M191.113 39.8559C191.113 39.0138 191.845 38.2815 192.724 38.2815C193.603 38.2815 194.372 39.0138 194.372 39.8559C194.372 40.7347 193.603 41.5036 192.724 41.5036C191.845 41.5036 191.113 40.7347 191.113 39.8559Z",
    fill: "#e9602a",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M220.504 41.1375H218.16L215.707 35.1325H202.708L200.255 41.1375H197.912L207.908 16.7149H210.507L220.504 41.1375ZM215.048 33.2285L209.189 18.7654L203.367 33.2285H215.048Z",
    fill: "#e9602a",
    fillOpacity: 0.35
  })), /*#__PURE__*/React.createElement("path", {
    d: "M220.504 41.1375H218.16L215.707 35.1325H202.708L200.255 41.1375H197.912L207.908 16.7149H210.507L220.504 41.1375ZM215.048 33.2285L209.189 18.7654L203.367 33.2285H215.048Z",
    fill: "#e9602a",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M226.816 41.1375H224.729V16.7149H226.816V41.1375Z",
    fill: "#e9602a",
    fillOpacity: 0.35
  })), /*#__PURE__*/React.createElement("path", {
    d: "M226.816 41.1375H224.729V16.7149H226.816V41.1375Z",
    fill: "#e9602a",
    style: {
      mixBlendMode: "color-dodge"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    fill: "#e9602a"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_38_5468_clip_path",
    transform: "translate(40 40)",
    fill: "#e9602a"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6725 58.2749C44.5079 58.2749 57.345 45.2296 57.345 29.1375C57.345 13.0453 44.5079 0 28.6725 0C12.8371 0 0 13.0453 0 29.1375C0 45.2296 12.8371 58.2749 28.6725 58.2749ZM33.2191 33.7241L41.688 16.27L24.2338 24.7388L15.765 42.193L33.2191 33.7241Z",
    fill: "#e9602a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6654 41.1375H77.1478L67.701 16.7149H73.6327L80.4066 35.4987L87.1439 16.7149H93.0756L83.6654 41.1375Z",
    fill: "#e9602a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.009 41.1375H111.334L109.796 36.9267H98.8847L97.3468 41.1375H91.6348L101.082 16.7149H107.599L117.009 41.1375ZM108.368 32.423L104.34 21.2186L100.276 32.423H108.368Z",
    fill: "#e9602a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.95 37.6956L120.806 33.7411C122.527 35.5353 125.2 37.0365 128.568 37.0365C131.425 37.0365 132.816 35.6817 132.816 34.2904C132.816 32.4596 130.692 31.8371 127.873 31.178C123.882 30.2626 118.756 29.1642 118.756 23.7085C118.756 19.6441 122.271 16.3487 128.019 16.3487C131.901 16.3487 135.123 17.5204 137.539 19.754L134.647 23.562C132.669 21.7312 130.033 20.8891 127.653 20.8891C125.31 20.8891 124.065 21.9143 124.065 23.3789C124.065 25.0266 126.115 25.5392 128.935 26.1983C132.962 27.1137 138.089 28.322 138.089 33.7411C138.089 38.2082 134.903 41.5769 128.312 41.5769C123.625 41.5769 120.257 40.0024 117.95 37.6956Z",
    fill: "#e9602a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.834 41.1375H147.598V21.2918H140.458V16.7149H159.937V21.2918H152.834V41.1375Z",
    fill: "#e9602a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.89 31.3977V16.7149H169.163V31.2146C169.163 34.6199 171.03 36.9633 174.838 36.9633C178.573 36.9633 180.441 34.6199 180.441 31.2146V16.7149H185.713V31.3611C185.713 37.4393 182.235 41.5769 174.838 41.5769C167.369 41.5769 163.89 37.4027 163.89 31.3977Z",
    fill: "#e9602a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.113 39.8559C191.113 39.0138 191.845 38.2815 192.724 38.2815C193.603 38.2815 194.372 39.0138 194.372 39.8559C194.372 40.7347 193.603 41.5036 192.724 41.5036C191.845 41.5036 191.113 40.7347 191.113 39.8559Z",
    fill: "#e9602a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.504 41.1375H218.16L215.707 35.1325H202.708L200.255 41.1375H197.912L207.908 16.7149H210.507L220.504 41.1375ZM215.048 33.2285L209.189 18.7654L203.367 33.2285H215.048Z",
    fill: "#e9602a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.816 41.1375H224.729V16.7149H226.816V41.1375Z",
    fill: "#e9602a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVastuLogo);
export default __webpack_public_path__ + "static/media/vastu-logo.44df55d39845bfd0d2ee7e6d34ef2e97.svg";
export { ForwardRef as ReactComponent };